(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/hooks/assets/javascripts/use-clear-coupon-board.js') >= 0) return;  svs.modules.push('/components/tipsen/hooks/assets/javascripts/use-clear-coupon-board.js');
"use strict";

const _React = React,
  useCallback = _React.useCallback;
const _ReactRedux = ReactRedux,
  useDispatch = _ReactRedux.useDispatch,
  useSelector = _ReactRedux.useSelector;
const clearCouponBoard = svs.components.tipsen.engine.actions.clearCouponBoard;
const selectCouponEmpty = svs.components.tipsen.engine.selectors.couponSelectors.selectCouponEmpty;
const Confirm = svs.components.dialog.Confirm;
const useClearCouponBoard = couponId => {
  const dispatch = useDispatch();
  const isCouponEmpty = useSelector(state => selectCouponEmpty(state, couponId));
  return useCallback(index => {
    if (!isCouponEmpty) {
      svs.components.dialog.api.add(new Confirm({
        actions: [{
          title: 'Avbryt'
        }, {
          callback() {
            svs.components.dialog.api.close();
            dispatch(clearCouponBoard({
              couponId,
              boardIndex: index
            }));
          },
          title: 'Rensa'
        }],
        message: [{
          text: 'Vill du fortsätta ändå?',
          type: svs.components.dialog.message.TEXT
        }],
        branding: svs.components.dialog.branding.SPORT,
        icon: 'dustbin',
        title: "Dina tecken p\xE5 rad ".concat(index + 1, " kommer att rensas")
      }));
    }
  }, [couponId, dispatch, isCouponEmpty]);
};
setGlobal('svs.components.tipsen.hooks.useClearCouponBoard', useClearCouponBoard);

 })(window);